export const removeScript = () => {
  document.querySelector('.jiraScripts')!.remove();
};
